function MedicalHistory({ records }) {
  return (
    <div className="flex flex-col gap-2">
      {records.map((x) => (
        <div className="border shadow-sm rounded-md flex gap-4 p-2 items-center">
          <div className="">{x.medicalRecordId}</div>
          <div className="flex flex-col gap-2">
            <div className="text-lg font-semibold">
              {RecordTypeFromId(x.recordType)}
            </div>
            <div>
              {x.recordDate ? (
                new Date(x.recordDate).toLocaleDateString()
              ) : (
                <span
                  className="text-yellow-500 hover:text-yellow-600"
                  title="Record date is not supplied, this is the date created in the database"
                >
                  {new Date(x.createdDate).toLocaleDateString()}
                </span>
              )}
            </div>
          </div>
          <div className="">{x.notes}</div>
        </div>
      ))}
    </div>
  );
}
function RecordTypeFromId(id) {
  switch (id) {
    case 0:
      return "Unknown";
    case 1:
      return "Fix";
    case 2:
      return "Snap";
    case 3:
      return "FVRCP";
    case 4:
      return "Rabies";
    case 5:
      return "History";
    case 6:
      return "Weight";
    default:
      return "";
  }
}
export default MedicalHistory;
